import React, { useEffect, useState, useRef } from 'react';
import HomeLayout from '../../components/home_page/HomeLayout';
import Form from '../../components/Form/Form';
import MasterListFooter from '../../components/Footer/Master_Footer/MasterListFooter';
import NavFooterLayout from '../../components/NavNameOfComponent/NavFooterLayout';
import { useDropdownKeyboardNavigation } from '../../components/Custom_Hooks/useDropdownKeyboardNavigation';
import { useDropdownScroll } from '../../components/Custom_Hooks/useDropdownScroll';
import BranchCreateModal from './BranchCreateModal';
import DeletConfirm from '../../components/Modal/DeletConfirm';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { branchList, branchDelete } from '../../redux/actions/action-creator';

function BranchCreate() {
    const dispatch = useDispatch();
    const { userData } = useSelector(state => state.auth);
    const company_id = userData?.company_id || userData?.id;

    const [loading, setLoading] = useState(true);
    const [all_data, setAll_data] = useState([]);
    const [isCreateOpen, setIsCreateOpen] = useState(false);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [isView, setIsView] = useState(false);
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Load branches from API
    const loadBranches = () => {
        if (!company_id) return;
        setLoading(true);
        dispatch(branchList({ company_id }))
            .then(res => setAll_data(Array.isArray(res?.data) ? res.data : []))
            .catch(() => setAll_data([]))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        loadBranches();
    }, [company_id]);

    const handleOpenAlter = (item) => {
        setSelectedBranch(item);
        setIsView(false);
        setIsCreateOpen(true);
    };

    const handleOpenView = (item) => {
        setSelectedBranch(item);
        setIsView(true);
        setIsCreateOpen(true);
    };

    const { selectedItemIndex, setSelectedItemIndex } = useDropdownKeyboardNavigation({
        items: all_data,
        state: !isCreateOpen && !isDeleteOpen,
        initialIndex: 0,
        enableAlphaJump: true,
        getLabel: (item) => item?.name || '',
        onItemAltCSelect: () => {
            setSelectedBranch(null);
            setIsView(false);
            setIsCreateOpen(true);
        },
        onItemSelect: (item) => handleOpenView(item),
        onItemControlEnterSelect: (item) => handleOpenAlter(item),
        onItemAltDSelect: () => setIsDeleteOpen(true),
    });

    useDropdownScroll({ dropdownRef, selectedItemIndex });

    // Called when modal saves successfully
    const handleBranchCreated = () => {
        loadBranches(); // Refresh list from API
    };

    const handleDeleteSubmit = (e) => {
        if (e) e.preventDefault();
        const branch = all_data[selectedItemIndex];
        if (!branch) { setIsDeleteOpen(false); return; }

        dispatch(branchDelete({ id: branch.id, company_id }))
            .then(() => {
                toast.success('Branch deleted successfully!', { position: toast.POSITION.TOP_CENTER, autoClose: 1500 });
                loadBranches();
            })
            .catch(() => {
                toast.error('Failed to delete branch.', { position: toast.POSITION.TOP_CENTER, autoClose: 1500 });
            });
        setIsDeleteOpen(false);
    };

    useEffect(() => {
        const handleFooterClick = (e) => {
            const btn = e.target.closest('button');
            if (!btn) return;
            if (btn.textContent.includes('Create Master') && !isCreateOpen) {
                setSelectedBranch(null);
                setIsView(false);
                setIsCreateOpen(true);
            } else if (btn.textContent.includes('Delete') && !isCreateOpen && !isDeleteOpen) {
                setIsDeleteOpen(true);
            } else if (btn.textContent.includes('Alter') && !isCreateOpen && all_data[selectedItemIndex]) {
                handleOpenAlter(all_data[selectedItemIndex]);
            }
        };
        document.addEventListener('click', handleFooterClick);
        return () => document.removeEventListener('click', handleFooterClick);
    }, [isCreateOpen, isDeleteOpen, all_data, selectedItemIndex]);

    return (
        <HomeLayout>
            {isCreateOpen && (
                <div style={{ zIndex: 10000 }}>
                    <BranchCreateModal
                        closeModal_sec={() => {
                            setIsCreateOpen(false);
                            setSelectedBranch(null);
                            setIsView(false);
                        }}
                        onSuccess={handleBranchCreated}
                        editData={selectedBranch}
                        viewOnly={isView}
                    />
                </div>
            )}

            <Form
                title='Branch Management'
                col='col-12'
                loading={loading}
                Footer={MasterListFooter}
                createMasterEnabled={true}
                deleteEnabled={true}
            >
                {isDeleteOpen && (
                    <div style={{ zIndex: 10000 }}>
                        <DeletConfirm
                            handleSubmit={handleDeleteSubmit}
                            loading={false}
                            closeModal={() => setIsDeleteOpen(false)}
                        />
                    </div>
                )}

                {/* Table Header */}
                <div className="row p-0 m-0 border_2_1px_top border_2_2px_bottom mt-0">
                    <div className="col-1 font_size p-0 m-0 px-1 text-end fw-bold" style={{ width: '5%' }}>Sr No.</div>
                    <div className="col-3 font_size p-0 m-0 px-1 text-start fw-bold" style={{ width: '25%' }}>Branch Name</div>
                    <div className="col-1 font_size m-0 p-0 px-1 text-end fw-bold" style={{ width: '10%' }}>Branch Code</div>
                    <div className="col-2 font_size m-0 p-0 px-1 text-start fw-bold" style={{ width: '13%' }}>Address</div>
                    <div className="col-2 font_size m-0 p-0 px-1 text-start fw-bold" style={{ width: '12%' }}>Under</div>
                    <div className="col-2 font_size m-0 p-0 px-1 text-start fw-bold" style={{ width: '15%' }}>Branch Manager</div>
                    <div className="col-1 font_size m-0 p-0 px-1 text-end fw-bold" style={{ width: '12%' }}>Mobile</div>
                    <div className="col-1 font_size p-0 m-0 px-1 text-start fw-bold" style={{ width: '8%' }}>Status</div>
                </div>

                {/* Table Body */}
                <div className='row gx-0 p-0 mb-2' style={{ overflowY: 'hidden' }}>
                    <div className='col m-0 p-0' ref={dropdownRef} style={{ overflowY: 'auto', height: '75.3vh' }}>
                        {all_data.length === 0 && !loading && (
                            <div style={{ textAlign: 'center', padding: '30px', color: '#999', fontSize: '0.9rem' }}>
                                No branches found. Press <b>Alt+C</b> or click <b>Create Master</b> to add one.
                            </div>
                        )}
                        {all_data.map((item, index) => (
                            <div
                                key={item.id || index}
                                onClick={() => setSelectedItemIndex(index)}
                                onDoubleClick={() => handleOpenAlter(item)}
                                style={{ cursor: 'pointer' }}
                                className={`row gx-0 p-0 m-0 mt-0 ${index === selectedItemIndex ? 'selected' : ''}`}
                            >
                                <div className="col-1 font_size p-0 m-0 px-1 text-end" style={{ width: '5%' }}>{index + 1}</div>
                                <div className="col-3 font_size p-0 m-0 px-1 text-start" style={{ width: '25%' }}>{item.name}</div>
                                <div className="col-1 font_size m-0 p-0 px-1 text-end" style={{ width: '10%' }}>{item.branch_code || '-'}</div>
                                <div className="col-2 font_size m-0 p-0 px-1 text-start" style={{ width: '13%' }}>{item.address || '-'}</div>
                                <div className="col-2 font_size m-0 p-0 px-1 text-start" style={{ width: '12%' }}>Primary</div>
                                <div className="col-2 font_size m-0 p-0 px-1 text-start" style={{ width: '15%' }}>-</div>
                                <div className="col-1 font_size m-0 p-0 px-1 text-end" style={{ width: '12%' }}>{item.mobile || '-'}</div>
                                <div className="col-1 font_size p-0 m-0 px-1 text-start fw-bold" style={{
                                    width: '8%',
                                    color: item.status === 'Active' ? '#198754' : '#dc3545'
                                }}>
                                    {item.status}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <NavFooterLayout>
                    <b className='ps-2'>{all_data.length} Branch(es)</b>
                </NavFooterLayout>
            </Form>
        </HomeLayout>
    );
}

export default BranchCreate;
